import React, { useEffect } from 'react'
import smoothscroll from 'smoothscroll-polyfill'
import { v4 as uuidv4 } from 'uuid'

import { identify } from './service/mixpanel.service'
import { getDistinctId, setDistinctId } from './service/localStorage.service'
import { Quote } from './quote/quote.component'
import { StyledToastContainer } from './component-library/components/alerts/alerts.component.styles'
import { quoteTrackingService } from './quote/tracking.service'

smoothscroll.polyfill()

const App = () => {
  useEffect(() => {
    if (!getDistinctId()) {
      const newDistinctId = uuidv4()
      setDistinctId(newDistinctId)
      identify({ distinctId: newDistinctId })
    }
    quoteTrackingService.trackLandQuotingPage()
  }, [])
  return (
    <div>
      <StyledToastContainer />
      <Quote />
    </div>
  )
}

export { App }
